export enum MetadataType {
  FIND_INVESTORS = "FIND_INVESTORS",
  FIND_INVESTOR = "FIND_INVESTOR",
  DOCUMENT_QA = "DOCUMENT_QA",
}
